module.exports = __webpack_public_path__ + "img/GAMES-top.5f300ae6.jpg";